import { HttpHeaders } from "@angular/common/http";

export const environment = {
  production: false,
  contactFormUrl: 'https://api.dev.gtxinspections.com/submit',
  reCAPTCHASiteKey: '',
  HTTP_OPTIONS: {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  }
};
